// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__BvWW1","horizontalContainer":"gantt_horizontalContainer__RyVRU","wrapper":"gantt_wrapper__QT8eN"};